import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, ModalBody, ModalFoot, ModalHead } from '@dixa/lib-shared-habla';
import memoize from 'memoize-one';
import { useCallback } from 'react';
import { connect } from 'react-redux';
import { FieldArray, Form, formValueSelector, reduxForm, } from 'redux-form';
import { v4 as uuid } from 'uuid';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { getConfirmButtonVerb } from 'components/powerFlowShared/helpers/getConfirmButtonVerb';
import { FieldRepeater, RepeaterDivider } from 'fable/fieldRepeater';
import { FieldRoutes } from './components/fieldRoutes/fieldRoutes';
import { validate } from './validate';
const getDefaultRowProps = () => ({ urlPrefix: '', nextNodeId: uuid() });
const URLTriggerModalImpl = (props) => {
    const { node, nodeLabel, triggerClose, handleSubmit, destroy, replaceNode, dirty: isChanged, } = props;
    const closeModal = useCallback(() => {
        destroy();
        triggerClose();
    }, [destroy, triggerClose]);
    const handleSaveClick = useCallback((values) => {
        var _a;
        const defaultNextNodeId = ((_a = node.payload) === null || _a === void 0 ? void 0 : _a.defaultNextNodeId) || uuid();
        const nodeOptions = Object.assign(Object.assign({}, node), { badges: [], icon: '', isAction: false, isEditable: true, isRemovable: true, nodeType: FlowNodeTypes.URL, payload: {
                routes: values.routes.map((route) => (Object.assign({ urlPrefix: '' }, route))),
                defaultNextNodeId,
            }, overlay: [], text: '' });
        replaceNode(nodeOptions);
        triggerClose();
    }, [node, replaceNode, triggerClose]);
    return (_jsx(Box, Object.assign({ width: "600px" }, { children: _jsxs(Form, Object.assign({ onSubmit: handleSubmit(handleSaveClick) }, { children: [_jsxs(ModalHead, Object.assign({ title: nodeLabel, onClose: closeModal }, { children: ["URL triggers can be used to change how the Dixa Messenger routes based on which URL the customer is visiting, when he or she starts the conversation.", _jsx("br", {}), _jsx("br", {}), "E.g. you can have one queue for your check-out pages and one for everything else. ", _jsx("i", { children: "https://example.com/support" }), " or", ' ', _jsx("i", { children: "https://example.com/checkout" }), _jsx("br", {}), _jsx("br", {}), "* Note that the URL trigger node will try each url you provide here one by one, and route based on the", ' ', _jsx("strong", { children: "first one that matches" }), ". Make sure you enter your", ' ', _jsx("strong", { children: "more specific URLs first." })] })), _jsx(ModalBody, { children: _jsx(FieldArray, { buttonProps: { placement: 'outside', label: 'Add URL' }, component: FieldRepeater, defaultRowProps: getDefaultRowProps, divider: _jsx(RepeaterDivider, {}), rowProps: {}, name: "routes", rowComponent: FieldRoutes, title: "URLs" }) }), _jsx(ModalFoot, { confirmOnClick: handleSubmit(handleSaveClick), confirmName: getConfirmButtonVerb(node), confirmProps: { disabled: !isChanged }, cancelOnClick: closeModal })] })) })));
};
const formName = 'messengerURLTriggerModal';
const getMemoizedUUID = memoize((_node) => uuid());
const mapStateToProps = (state, ownProps) => {
    var _a;
    const formVal = formValueSelector(formName);
    const { node } = ownProps;
    return {
        initialValues: {
            routes: ((_a = node.payload) === null || _a === void 0 ? void 0 : _a.routes) ||
                [
                    {
                        urlPrefix: '',
                        // Use memoized function so UUID doesn't constantly change
                        nextNodeId: getMemoizedUUID(node),
                    },
                ],
        },
        routes: formVal(state, 'routes'),
    };
};
export const URLTriggerModal = connect(mapStateToProps)(reduxForm({
    form: formName,
    enableReinitialize: true,
    validate,
})(URLTriggerModalImpl));
